import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { toursService } from '../../../services/toursService';


const AddTour = () => {
  const navigate = useNavigate();
  const redirect_uri = '/tours';
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    toursService.addTour(data)
      .then((result) => {
        alert("Tour Added Successfully!");
        reset();
        navigate(redirect_uri);
      })
      .catch(err => console.error(err));
  };

  return (
    <div className="py-24 bg-slate-50 min-h-screen mt-16 px-6">
        <div className="max-w-3xl mx-auto">
            <div className="text-center mb-16">
                <h4 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight lowercase">add a new <span className="text-amber-500">tour package</span></h4>
                <div className="w-24 h-2 bg-amber-500 mx-auto mt-6 rounded-full shadow-lg shadow-amber-500/20"></div>
            </div>

            <div className="bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border border-slate-100 p-8 md:p-16">
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
                    <div className="space-y-6">
                        <div>
                            <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Tour Title</label>
                            <input
                                {...register("title", { required: true })}
                                placeholder="e.g. 3 Days in Paris"
                                className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold placeholder:font-medium"
                            />
                        </div>
                        
                        <div>
                            <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Image URL</label>
                            <input
                                {...register("img", { required: true })}
                                type="url"
                                placeholder="https://example.com/image.jpg"
                                className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold placeholder:font-medium"
                            />
                        </div>

                        <div>
                            <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Description</label>
                            <textarea
                                {...register("description", { required: true })}
                                rows="5"
                                placeholder="Provide details about the tour package..."
                                className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold placeholder:font-medium resize-none"
                            />
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div>
                                <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Cost (per person)</label>
                                <div className="relative">
                                    <span className="absolute left-6 top-1/2 -translate-y-1/2 text-slate-400 font-bold">$</span>
                                    <input
                                        {...register("cost", { required: true })}
                                        type="number"
                                        placeholder="500"
                                        className="w-full pl-10 pr-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold placeholder:font-medium"
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-xs font-black uppercase tracking-widest text-slate-400 mb-3 ml-1">Duration (days)</label>
                                <input
                                    {...register("duration", { required: true })}
                                    type="number"
                                    placeholder="3"
                                    className="w-full px-6 py-4 bg-slate-50 border-2 border-transparent rounded-2xl focus:ring-0 focus:border-amber-500 focus:bg-white transition-all text-slate-700 font-bold placeholder:font-medium"
                                />
                            </div>
                        </div>
                    </div>

                    {Object.keys(errors).length > 0 && (
                        <div className="flex items-center p-4 bg-red-50 text-red-600 rounded-2xl border border-red-100">
                            <i className="fas fa-exclamation-circle mr-3 text-lg"></i>
                            <p className="text-sm font-bold uppercase tracking-wide">Please fill in all required fields.</p>
                        </div>
                    )}
                    
                    <div className="pt-4">
                        <button 
                            type="submit" 
                            className="w-full bg-slate-900 hover:bg-amber-500 text-white hover:text-slate-900 font-black py-5 rounded-2xl shadow-xl hover:shadow-amber-500/20 transition-all active:scale-[0.98] uppercase tracking-[0.2em] text-sm"
                        >
                            Add Tour Package
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  );
};

export default AddTour;